"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLES = void 0;
// 사용자 역할 (api·web·admin 공통)
// USER  : 서비스(web)만 이용
// ADMIN : 서비스(web) + 관리자(admin) 모두 이용
exports.ROLES = {
    USER: "USER",
    ADMIN: "ADMIN",
};
